import * as z from "zod";
import { WeightSchema } from "../outbound-labels/util";
import { FulfillmentGroupDataSchema } from "./fulfillment-group";
import { FulfillmentOrderLineItemSchema } from "./fulfillment-order-line-item";

const BatchSuggestionSchema_ = z.object({
  batchKey: z.string(),
  totalItemCount: z.number(),
  items: z.array(FulfillmentOrderLineItemSchema),
  lineItemsPerOrder: z.number(),
  weightPerOrder: WeightSchema,
  totalShipments: z.number(),
});
export const BatchSuggestionSchema: z.ZodType<BatchSuggestion> =
  BatchSuggestionSchema_;
export interface BatchSuggestion
  extends z.infer<typeof BatchSuggestionSchema_> {}

const BatchSuggestionWithGroupsSchema_ = BatchSuggestionSchema_.extend({
  fulfillmentGroups: z.array(FulfillmentGroupDataSchema).nullish(),
});
export const BatchSuggestionWithGroupsSchema: z.ZodType<BatchSuggestionWithGroups> =
  BatchSuggestionWithGroupsSchema_;
export interface BatchSuggestionWithGroups
  extends z.infer<typeof BatchSuggestionWithGroupsSchema_> {}
